import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, isValidEmail } from "../lib/api";
import { useT } from "../lib/i18n";
import { AuthShell } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const ForgotPassword = () => {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!isValidEmail(email)) return setError(t("auth.err.email"));
    setBusy(true);
    try {
      const res = await api("/auth/forgot-password", { method: "POST", body: JSON.stringify({ email }) });
      setSent(res.message || "Verstuurd.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgot.title")}>
      {sent ? (
        <div className="text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto text-success" size={40} />
          <p className="mt-4 text-sm text-slate-600">{sent}</p>
          <Button asChild variant="outline" className="mt-6 rounded-xl">
            <Link to="/login">{t("nav.login")}</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-slate-500">{t("auth.forgot.subtitle")}</p>
          <div>
            <Label className="text-sm font-semibold text-navy">{t("common.email")}</Label>
            <Input className="mt-2 rounded-xl" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          {error && <p className="rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full rounded-xl bg-brandblue hover:bg-brandblue/90">
            {busy ? <Loader2 className="animate-spin" size={18} /> : t("auth.forgot.submit")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
